import { useCallback, useState } from 'react';

import { AuthCode } from '@features/method-tester/components/authCode.tsx';
import { BankAccountToken } from '@features/method-tester/components/bankAccountToken.tsx';
import { CameraConsent } from '@features/method-tester/components/cameraConsent.tsx';
import { Consent } from '@features/method-tester/components/consent.tsx';
import { DeepLink } from '@features/method-tester/components/deepLink.tsx';
import { Location } from '@features/method-tester/components/location.tsx';
import { Payment } from '@features/method-tester/components/payment.tsx';
import { PaymentIntegration } from '@features/method-tester/components/paymentIntegration.tsx';
import { useIsMobileScreen } from '@hooks/index.ts';

import { widgetList } from './constants/index.ts';
import { Widget } from './types/widgetTypes.ts';

import { useJsBridgeVersion } from '@/context/JsBridgeVersionContext.tsx';
import GenericUI from '@/features/method-tester/components/GenericUI/index.tsx';
import { LaunchUri } from '@/features/method-tester/components/launchUri.tsx';
import { SystemInfo } from '@/features/method-tester/components/systemInfo.tsx';
import { WifiInfo } from '@/features/method-tester/components/wifiInfo.tsx';
import { Dropdown } from '@asphalt-react/selection';
import { Heading } from '@asphalt-react/typography';

const widgetMap = {
  GenericUI: <GenericUI />,
  PaymentIntegration: <PaymentIntegration />,
  Location: <Location />,
  AuthCode: <AuthCode />,
  DeepLink: <DeepLink />,
  LaunchUri: <LaunchUri />,
  Payment: <Payment />,
  SystemInfo: <SystemInfo />,
  WifiInfo: <WifiInfo />,
  CameraConsent: <CameraConsent />,
  Consent: <Consent />,
  BankAccountToken: <BankAccountToken />,
};

export function MethodTester() {
  const [selectedWidget, setSelectedWidget] = useState<Widget | null>(null);
  const isMobileScreen: boolean = useIsMobileScreen();
  const { version } = useJsBridgeVersion();
  // const [searchValue, setSearchValue] = useState<string>('');

  // const handleSearchChange = useCallback((value: string) => {
  //   setSearchValue(value);
  // }, []);
  const onClick = useCallback((event: Widget) => {
    setSelectedWidget(event);
  }, []);

  return (
    <div
      className={`flex flex-col items-center w-full m-auto ${isMobileScreen ? '' : 'px-[20px]'} rounded-lg`}
    >
      <div data-test-id="testId">Adding for QA cache testing</div>
      <Heading h5>JSSDK version: {version}</Heading>
      {/* <Banner
        handleSearchChange={handleSearchChange}
        searchValue={searchValue}
      />

      <IntegrationWarningModal /> */}
      <div
        className="py-3 w-full flex justify-center"
        data-test-id="widget-dropdown"
      >
        <Dropdown
          items={widgetList}
          onChange={(event: Widget) => onClick(event)}
          placeholder="Select an option"
          stretch={isMobileScreen ? true : false}
          aria-label="Select an option"
        />
      </div>
      {/* {searchValue} */}
      <section className="w-full px-2 py-3 pb-[150px]">
        {selectedWidget?.key && widgetMap[selectedWidget.key]}
      </section>
    </div>
  );
}
